import axios from 'axios';

import { Qualification } from 'components/types';

import {
  PREFERRED_ROSTER_QUALIFICATIONS,
  QUALIFICATIONS,
  ROSTER_QUALIFICATIONS
} from 'RestAPIs/endpoints';

type POSTBody = {
  name: string;
  code: string;
};

export const getQualifications = () =>
  axios.get<Qualification[]>(QUALIFICATIONS);

export const addQualification = (body: POSTBody) =>
  axios.post<Qualification>(QUALIFICATIONS, { ...body });

export type RosterQualificationsByCostCenterAndDate = {
  costCenterId: number;
  startDate: string;
  endDate: string;
  qualificationId?: string;
};

export type RosterQualificationsPreferred = {
  costCenterId: number;
  qualificationId?: string;
};

export const getRosterQualifications = ({
  costCenterId,
  startDate,
  endDate
}: RosterQualificationsByCostCenterAndDate) => {
  return axios.get<RosterQualificationsByCostCenterAndDate[]>(
    `${ROSTER_QUALIFICATIONS}?costCenters=${costCenterId}&startDate=${startDate}&endDate=${endDate}`
  );
};

export const getRosterQualificationsPreferred = ({
  costCenterId
}: RosterQualificationsPreferred) => {
  const url = PREFERRED_ROSTER_QUALIFICATIONS.replace(
    ':costCenterId',
    costCenterId.toString()
  );

  return axios.get<RosterQualificationsPreferred>(`${url}`);
};

export const addRosterQualifications = (
  costCenterId: number,
  qualificationId: string
) => {
  const url = PREFERRED_ROSTER_QUALIFICATIONS.replace(
    ':costCenterId',
    costCenterId.toString()
  );

  return axios.post<RosterQualificationsPreferred>(
    `${url}?qualificationId=${qualificationId}`
  );
};

export const removeRosterQualifications = (
  costCenterId: number,
  qualificationId: string
) => {
  const url = PREFERRED_ROSTER_QUALIFICATIONS.replace(
    ':costCenterId',
    costCenterId.toString()
  );

  return axios.delete<RosterQualificationsPreferred>(
    `${url}?qualificationId=${qualificationId}`
  );
};
